export default __webpack_public_path__ + "static/media/linkedin.29edd1ee.webp";